export default __webpack_public_path__ + "static/250-49bfc956933002c4c5e36019076ce39c.jpg";